
const TYPES = [
  {
    label: '动物',
    value: 'animal'
  },
  {
    label: '水果',
    value: 'fruit'
  }
]

const FRUITS = [
  {
    label: '香蕉',
    value: 'banana'
  },
  {
    label: '草莓',
    value: 'strawberry'
  },
  {
    label: '苹果',
    value: 'apple'
  }, {
    label: '梨',
    value: 'pear'
  },
  {
    label: '菠萝',
    value: 'pineapple'
  }
]

const ANIMALS = [
  {
    label: '猴子',
    value: 'monkey'
  },
  {
    label: '大象',
    value: 'dolphin'
  },
  {
    label: '老虎',
    value: 'tiger'
  },
  {
    label: '狗',
    value: 'dog'
  }, {
    label: '猫',
    value: 'cat'
  }
]

export const DEMO_TYPES = {
  request: function() {
    return Promise.resolve(TYPES)
  }
}

export const DEMO_FRUITS = {
  request: function() {
    return Promise.resolve(FRUITS)
  }
}

export const DEMO_BY_TYPE = {
  request: function({ loaderParam: type }: any) {
    if (type === 'animal') {
      return Promise.resolve(ANIMALS)
    } else if (type === 'fruit') {
      return Promise.resolve(FRUITS)
    }
    return Promise.resolve([])
  }
}
